/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SaturdayInputs */

const en_saturday = /** @type {(inputs: SaturdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday`)
};

const de_saturday = /** @type {(inputs: SaturdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samstag`)
};

/**
* | output |
* | --- |
* | "Saturday" |
*
* @param {SaturdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const saturday = /** @type {((inputs?: SaturdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SaturdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saturday(inputs)
	return de_saturday(inputs)
});